import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getEventDate } from '@lib/utils';

import styles from './styles.module.scss';

const {
  card,
  card_content,
  card_image,
  heading,
  author_name,
  loading_placeholder,
  date_range,
  event_details,
  theme_basic,
  theme_large
} = styles;

const fetch = require('node-fetch');

// ---------------------------------------------------------

const EventCard = ({
  linkUrl,
  headline,
  authorName,
  featuredImage,
  eventDate,
  expirationDate,
  schedule,
  eventDetails,
  theme
}) => {
  const [image, setImage] = useState(featuredImage);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!image) {
      fetch(
        `https://api.embedly.com/1/extract?meta_images=true&url=${linkUrl}&key=${process.env.NEXT_PUBLIC_EMBEDLY}`
      )
        .then((response) => response.json())
        .then((data) => {
          setImage(data.images[0].url);
        })
        .catch((err) => {
          console.log(err);
          setImage(
            'https://images.ctfassets.net/wzzep3ntdgx4/4V3cWpoV2LctBsJYc6SnSf/4ef45ecd14a78222b508078d9fe9d345/AdobeStock_376819599.jpeg'
          );
        });
    }
  }, []);

  return (
    <a
      href={linkUrl}
      target="_blank"
      className={classNames(card, {
        [theme_basic]: theme === 'basic',
        [theme_large]: theme === 'large'
      })}
      rel="noreferrer"
    >
      <div className={card_image}>
        <span class={date_range}>{getEventDate(schedule, eventDate, expirationDate)}</span>

        <img alt={headline} src={image} onLoad={() => setIsLoaded(true)}></img>
        {!isLoaded && <div className={loading_placeholder}></div>}
      </div>
      <div className={card_content}>
        <span className={heading}>{headline}</span>
        {eventDetails && <span className={event_details}>{eventDetails}</span>}
        {authorName && <span className={author_name}>{authorName}</span>}
      </div>
    </a>
  );
};

EventCard.propTypes = {
  /**
   * Specifies the author of the content
   */
  authorName: PropTypes.string,

  /**
   * Specifies the Community Page Featured Image - receives a default image if none
   */
  featuredImage: PropTypes.string,

  /**
   * Specifies the headline
   */
  headline: PropTypes.string,

  /**
   * Specifies the link url
   */
  linkUrl: PropTypes.string,

  /**
   * Specifies the records theme
   */
  theme: PropTypes.string,
  eventDate: PropTypes.string,
  expirationDate: PropTypes.string,
  schedule: PropTypes.string,
  eventDetails: PropTypes.string
};

export default EventCard;
